export const GUIDE_LANGUAGE_OPTIONS = [
  { code: "original", label: "English" },
  { code: "da", label: "Dansk" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "nl", label: "Nederlands" },
  { code: "sv", label: "Svenska" },
  { code: "ja", label: "日本語" },
] as const;

export type GuideLanguageCode = (typeof GUIDE_LANGUAGE_OPTIONS)[number]["code"];
export type GuideTranslatedLanguageCode = Exclude<GuideLanguageCode, "original">;

export function isGuideTranslatedLanguageCode(value: string): value is GuideTranslatedLanguageCode {
  return GUIDE_LANGUAGE_OPTIONS.some((opt) => opt.code === value && opt.code !== "original");
}

export function guidePathForLanguage({
  slug,
  lang,
}: {
  slug: string;
  lang?: GuideTranslatedLanguageCode | null;
}): string {
  const encodedSlug = encodeURIComponent(slug);
  return lang ? `/${lang}/guides/${encodedSlug}` : `/guides/${encodedSlug}`;
}
